import React from "react";
import DailySubscriptions from "./DailySubscriptions";

const Subscriptions = () => <DailySubscriptions />;

export default Subscriptions;
